<template>
    <div class="footer">
      <div class="hidden-sm-and-down">
          <div class="footertop">
            <div class="footerbox">
                <ul>
                    <li>关于我们</li>
                    <li> <router-link to="/Brandhistory">品牌历程</router-link></li>
                    <li> <router-link to="/Callme">联系我们</router-link></li>
                </ul>
                <ul>
                    <li>关注我们</li>
                    <li>
                        <el-dropdown>
                        <div class="el-dropdown-link">
                            <img src="../assets/weixinicon.png" alt="" style="vertical-align:middle;">
                            <span style="font-size: 14px;color: #fff;cursor:pointer">微信公众号：刘燕酿制官方</span>
                        </div>
                        <el-dropdown-menu class="gzh" slot="dropdown">
                            <el-dropdown-item>
                            <div style="position: relative;width: 2rem;height: 2.5185rem;"
                                :style="{'background':'url('+require('../assets/lynzfwcx.jpg')+') no-repeat center center/100% 100%'}"
                            >
                                <img style="position: absolute; width: 75%; top: 16%; left: 50%; transform: translateX(-50%);" src="../../static/lyewm.jpg" alt="" />
                            </div>
                        </el-dropdown-item>
                        </el-dropdown-menu>
                        </el-dropdown>
                    </li>
                    <li>
                        <img src="../assets/weibo.png" alt="">
                        <a href="https://weibo.com/u/6279792514">微博：刘燕酿制LIUYANBREW</a>
                    </li>
                </ul>
            </div>
            <!-- <el-row class="footerbox">
                <el-col :md="8" :sm="8" :xs="8">
                    <ul>
                        <li>客户服务</li>
                        <li><router-link to="/question">常见问题</router-link></li>
                        <li><router-link :to="{ name:'question', query: {id: 2} }">客服规定</router-link></li>
                    </ul>
                </el-col>
                <el-col :md="12" :sm="12" :xs="12">
                    <div class="grid-content bg-purple-light">
                        <ul>
                            <li>关于我们</li>
                            <li> <router-link to="/Brandhistory">品牌历程</router-link></li>
                            <li> <router-link to="/Callme">联系我们</router-link></li>
                        </ul>
                    </div>
                </el-col>
                <el-col :md="12" :sm="12" :xs="12">
                    <div class="grid-content bg-purple">
                        <ul>
                            <li>关注我们</li>
                            <li>
                              <el-dropdown style="width:80%;">
                                <span class="el-dropdown-link">
                                  <img src="../assets/weixinicon.png" alt="">
                                    <span style="font-size: 14px;color: #fff;cursor:pointer">微信公众号：刘燕酿制官方</span>
                                </span>
                                <el-dropdown-menu class="gzh" slot="dropdown">
                                  <el-dropdown-item>
                                    <div style="position: relative;width: 2rem;height: 2.5185rem;"
                                        :style="{'background':'url('+require('../assets/lynzfwcx.jpg')+') no-repeat center center/100% 100%'}"
                                    >
                                        <img style="position: absolute; width: 75%; top: 16%; left: 50%; transform: translateX(-50%);" src="../../static/lyewm.jpg" alt="" />
                                    </div>
                                </el-dropdown-item>
                                </el-dropdown-menu>
                              </el-dropdown>
                            </li>
                            <li><img src="../assets/weibo.png" alt=""><a href="https://weibo.com/u/6279792514">微博：刘燕酿制LIUYANBREW</a></li>
                        </ul>
                    </div>
                </el-col>
            </el-row> -->
        </div>
        <div class="footercent">
            <div class="xicon">
                <el-row :gutter="10" >
                    <el-col :md="8" :sm="8" :xs="8">
                        <div class="grid-content bg-purple">
                        <h4>
                            <a href="tel:4000017748">
                            <img src="../assets/phone.png" alt=""/>
                            400-001-7748
                            </a>
                        </h4>
                        </div>
                    </el-col>
                    <el-col :md="8" :sm="8" :xs="8">
                        <div class="grid-content bg-purple">
                        <h4>
                            <a style="color: #ebca20;" target="_blank" href="https://kx.xcc.cn/newCan/2023120110266002031">
                            <img src="../../static/foticon.png" style="width: 100px;" alt=""/>
                            <!-- 315认证 -->
                            </a>
                            <a style="color: #ebca20;" target="_blank" href="https://si.trustutn.org/info?sn=340231215040947568859&certType=1">
                            <img src="../../static/foticon2.jpg" style="width: 100px;" alt=""/>
                            <!-- 315认证 -->
                            </a>
                        </h4>
                        </div>
                    </el-col>
                    <el-col :md="8" :sm="8" :xs="8">
                        <div class="grid-content bg-purple">
                        <h4>
                            <a>
                            <img src="../assets/zhengpin.png" alt=""/>
                            官方正品查询
                            </a>
                        </h4>
                        </div>
                    </el-col>
                </el-row>
            </div>

        </div>
        <div class="banquan">
            <div>
              <!-- 修改版权位置 -->
<!--              <span>版权所有 耒阳君态贸易有限公司</span>-->
<!--              <span>湘ICP备2025129775号-1</span>-->
<!--              版权归深圳原汐生物科技有限公司所有  -->
              备案号：粤ICP备2025420556号-1
<!--                <span>&nbsp;<img src="../assets/guohui.png" style="width: 14px!important;vertical-align: top;"/>&nbsp;备案号：<a href="http://beian.miit.gov.cn" target="_blank">湘ICP备2023027912号-1</a></span>-->
            </div>
        </div>
      </div>

      <!-- 手机端显示 -->
      <div class="hidden-md-and-up mobfooter" v-if="mob">
        <div class="shopbox">
            <div class="bg-purple">
                 <img style="width:0.75rem" src="../../static/mobile/zp.png" alt="">
                  <span>官方正品查询</span>
            </div>
              <div class="bg-purple">
                  <a href="https://liuyanniangzhi.tmall.com/shop/view_shop.htm?spm=a220m.1000862.1000730.2.99114cb5FuwAPa&user_number_id=2212408218113&rn=3360f8e58e1e8a3539bd0ff5c27d6d10">
                        <img style="width:0.63rem" src="../../static/mobile/tm.png" alt="">
                        <span>天猫官方旗舰店</span>
                    </a>
            </div>
              <div class="bg-purple">
                 <a href="https://mall.jd.com/index-10094074.html">
                     <img style="width:0.95rem" src="../../static/mobile/jd.png" alt="">
                     <span>京东官方旗舰店</span>
                     </a>
            </div>
              <div class="bg-purple">
                  <a href="https://shop42755705.m.youzan.com/wscshop/showcase/homepage?kdt_id=42563537&redirect_count=1&is_silence_auth=1">
                 <img style="width:0.86rem" src="../../static/mobile/weixin.png" alt="">
                 <span>刘燕酿制官方旗舰店</span>
                 </a>
            </div>
        </div>
        <div style="width:100%;height:0.01rem;background: #FFFFFF;"></div>
        <div class="Touch">
            <!-- <div>
                <ul>
                    <li style="font-size:0.21rem;font-weight: bold;">客户服务</li>
                    <li><router-link to="/question">常见问题</router-link></li>
                    <li><router-link :to="{ name:'question', query: {id: 2} }">客服规定</router-link></li>
                </ul>
            </div> -->
            <div>
                 <ul>
                    <li style="font-size:0.21rem;font-weight: bold;">关于我们</li>
                    <li> <router-link :to="{ name:'Brand', query: {id: 2} }">品牌历程</router-link></li>
                    <li> <router-link to="/Callme">联系我们</router-link></li>
                </ul>
            </div>
            <div>
                <ul>
                    <li style="font-size:0.21rem;font-weight: bold;">关注我们</li>
                    <li>
                        <img style="width:0.19rem" src="../assets/weixinicon.png" alt="">
                        <a href="https://mp.weixin.qq.com/s/KIrbILYDUzPrLtuUsjskOw">微信公众号</a>
                    </li>
                    <li><img style="width:0.19rem" src="../assets/weibo.png" alt="">
                    <a href="https://weibo.com/u/6279792514">微博</a></li>
                </ul>
            </div>
        </div>
        <div class="tel">
            <img src="../../static/mobile/dianhua.png" alt=""><a href="tel:4000017748">400-001-7748 (点击拨出)</a>
        </div>
        <div class="copyright">
            <div>
                <a style="color: #ebca20;" target="_blank" href="https://kx.xcc.cn/newCan/2023120110266002031">
                            <img src="../../static/foticon.png" style="width:70px;" alt=""/>
                            <!-- 315认证 -->
                            </a>
              <!-- 修改版权位置 -->
<!--              <span>版权所有 耒阳君态贸易有限公司</span>-->
<!--              <span>湘ICP备2025129775号-1</span>-->
<!--              版权归深圳原汐生物科技有限公司所有  -->
              备案号：粤ICP备2025420556号-1
            </div>
               <!-- <div class="beian">
                    <span>&nbsp;<img style="width:.2rem;" src="../assets/guohui.png"/>备案号:<a href="http://beian.miit.gov.cn" target="_blank">湘ICP备2023027912号-1</a></span>
                    <span>
                    <a target="cyxyv" href="https://v.yunaq.com/certificate?domain=www.liuyanniangzhi.com&from=label&code=90040">
                        <img style="width: 0.41rem;vertical-align: unset;" src="../assets/label_sm_90040.png">
                    </a>
                    </span>
                    <span>
                        <a href="https://baike.shuidi.cn/companywiki-1947a95ec89397b0e279cf08095b0301.html" target="_blank">
                        <img src="../assets/senior_icon_01.png" alt="" style="width: 0.51rem;vertical-align: unset;">
                    </a>
                    </span>
               </div> -->
        </div>
      </div>
    </div>
</template>

<script>
export default {
    name: 'Footers',
    components: {  },
    directives: {  },
    data() {
        return {
             kexin: '<script src="//baike.shuidi.cn/wiki/trusted-link.js?digest=1947a95ec89397b0e279cf08095b0301&link_type=3" id="baikeCornerMarkerScript3">' + '<' + '/script>',
             mob:true
      }
    },
    mounted(){
           let routername = this.$route.path;
           if(routername === '/Brand'){
               if(this.$route.query.id == 2){
                   this.mob = false
               }
           }
    }

  };
</script>


<style lang="less" scoped>
/deep/.el-dropdown-menu__item{
  padding: unset;
}
/deep/.el-dropdown-menu el-popper{
  padding: unset;
  margin: unset;
}

.gzh.el-dropdown-menu{padding: .01rem;}
.footer{
         max-width: 1920px;
        margin: 0px auto;
        background: #000;
        .footertop{
            border-bottom: 1px solid #fff;
            padding-bottom: 1%;
               .footerbox{
                margin: 0 auto;
                padding-left: 2%;
                width: 600px;
                line-height: 2em;
                white-space:nowrap;
                display: flex;
                justify-content: space-evenly;
                text-align: left;
                ul{
                    font-size: 16px;
                    margin-top: 5%;
                    color: #666;
                    li:first-child{
                        color: #fff;
                    }
                    img{
                        // width: 20px;
                        height: 18px;
                        margin-right: 1%;
                    }
                    a{
                        color: #fff;
                        vertical-align: text-bottom;
                        font-size: 14px;
                    }

                        li:nth-child(2){
                        // margin: 5% 0;
                         color: #fff;
                    }
                }
            }
        }
        .footercent{
            width: 100%;
            border-bottom: 1px solid #666;
            .xicon{
                width: 80%;
                margin: 0 auto;
                text-align: center;
                padding: 10px;
                img{
                    width: 24px;
                    vertical-align: middle
                }
                h4 {
                    font-size: 16px;
                    font-weight: normal;
                }

                a {
                    color: #ddd;
                    vertical-align: sub;

                }

            }
        }
     .banquan {
      padding: 10px 0 6px;
      color: #999;
      font-size: 12px;
        span {
        display: inline-block;
        }

        a {
        color: #999;
        img{
            vertical-align: middle;
        }
        }

        a:hover {
        color: #fff;
        }
    }

}

@media (max-width: 991px) {
  .mobfooter{
    width: 100%;
    background: #000;
    margin-bottom: 1rem;
    .shopbox{
      padding-top: 0.44rem;
      padding-bottom: 0.31rem;
          margin: 0 0.1rem;
    //   margin: 0 0.3rem 0 0.48rem;
        display: -webkit-flex;
        display: flex;
        align-items: center;

      .bg-purple{
            width: 25%;
          a{
              color: #fff;
              font-size: 0.17rem;

          }
          span{
              width: 100%;
              height: 0.39rem;
              display: inline-grid;
                color: #fff;
                 font-size: 0.17rem;
                 padding-top: 0.22rem;
          }

      }
    }
    .Touch{
        margin: 0 0.6rem 0 1rem;
        display: -webkit-flex;
        display: flex;
        align-items: center;
        padding-bottom: 0.3rem;
        div{
            width:50%;
            color: #fff;
            text-align: left;
            padding-top: 0.35rem;
            // text-align: center;
            li{
                width: 100%;
                a{
                    font-size: 0.17rem;
                    color: #fff;
                }
                img{
                    width: 0.13rem;
                }

            }
             :nth-child(2){
                    padding: 0.2rem 0;
                }
        }

    }
    .tel{
        margin:0 0.49rem;
        border: 0.02rem solid #FFFFFF;
        text-align: center;
        img{
            width:0.28rem;
            margin-right: 0.24rem;
        }
        a{
            color: #fff;
            font-size: 0.27rem;
            padding: 0.17rem 0 0.2rem 0;
            display: inline-block;
            vertical-align: super;
        }
    }
    .copyright{
        padding-top: 0.21rem;
        padding-bottom: 0.51rem;
        color: #fff;
        text-align: center;
        div{
            margin-bottom: 0.09rem;
            img{
                width: 0.24rem;
                vertical-align: text-top;
                margin-right: 0.07rem;
            }
            span{
                font-size: 0.2rem;
                vertical-align: sub;
            }
        }
        .beian{
            a{
                color: #fff;
                font-size: 0.2rem;
            }

        }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Footers.vue